// WIP - Core data structure and functionalities (for avoiding circular references)

import { AppInfo, jituxDashboardAppId } from "../models";
import { context } from "./context";

export interface IMainLayoutAppsSubscriber {
  (apps: Array<AppInfo>): void;
}

export interface IUnsubscribeFunc {
  (): void;
}

export class JituxCore {
  private _apps: AppInfo[] = [];
  private get apps() {
    return this._apps;
  }

  constructor() {
    context.changedEvent.subscribe((key: string, value: any) => {
      if (key === "apps") this._apps = value;
    }, true);
  }

  private compareAppFunc(a: AppInfo, b: AppInfo): number {
    if (a.displayOrder != b.displayOrder) return a.displayOrder > b.displayOrder ? 1 : -1;
    return a.displayName > b.displayName ? 1 : -1;
  }

  private getMainLayoutApps(currentAppId: string): Array<AppInfo> {
    return currentAppId === jituxDashboardAppId
      ? this.apps.filter(x => x.alive && x.id !== jituxDashboardAppId &&
          Number(x.appConfigurations?.clientDashboardId ?? 0) === (context.get("clientDashboardId") ?? 0) &&
          context.hasItems(x.triggerContexts)).sort(this.compareAppFunc)
      : [];
  }

  subscribeMainLayoutApps(currentAppId: string, subscriber: IMainLayoutAppsSubscriber): IUnsubscribeFunc {
    subscriber(jituxCore.getMainLayoutApps(currentAppId));

    return context.changedEvent.subscribe((key: string) => {
      if (key === "apps" || key === "clientDashboardId") subscriber(jituxCore.getMainLayoutApps(currentAppId));
    });
  }
}

export const jituxCore = new JituxCore();
